import React from "react"
import gql from "graphql-tag"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { createMatchSelector } from "react-router-redux"
import routes from "../../routes"
import { formatRoute } from "../../helpers/sharedHelperFunctions"
import Header from "."
import { ErrorBoundary } from "@swipesense/error-handling"
import { graphqlDynamic } from "react-apollo-dynamic-query"

let sentToGA = false
const generateQuery = ({ facilityId }) => {
  if (facilityId) {
    return gql`
      query LoggedInUser($facilityId: ID!) {
        user {
          id
          firstName
          lastName
          applications {
            name
            url
          }
        }
        facility(id: $facilityId) {
          id
          name
        }
      }
    `
  } else {
    return gql`
      query LoggedInUser {
        user {
          id
          firstName
          lastName
          applications {
            name
            url
          }
        }
      }
    `
  }
}

const HeaderWithApollo = graphqlDynamic(generateQuery, {
  options: ({ facilityId }) => ({
    variables: { facilityId },
  }),
  props: ({ data: { error, loading, user, facility }, ownProps }) => {
    if (loading) {
      return { loading }
    } else if (error) {
      throw error
    }

    /* istanbul ignore next */
    if (!sentToGA) {
      /* istanbul ignore next */
      if (window.gtag !== undefined) {
        /* istanbul ignore next */
        window.gtag("set", {
          user_id: user ? user.id : undefined,
          event_user_id: user ? user.id : undefined, // backup for events property
          facility_id: facility ? facility.id : undefined,
          page: window.location.pathname,
        })
        sentToGA = true

        /* istanbul ignore next */
        window.gtag("event", "page_view", {
          page_location: window.location.pathname,
        })
      }
      /* istanbul ignore next */
      if (window.hj) {
        const facilityName = facility ? facility.name : "SwipeSense"
        window.hj("identify", user.id, { facility: facilityName })
      }
      /* istanbul ignore next */
      if (process.env.NODE_ENV === "production")
        window.Raven.setUserContext({
          id: user.id,
        })
    }

    const navLinks = facility
      ? [
          {
            label: "LOCATOR",
            path: formatRoute(routes.assets, { facilityId: facility.id }),
          },
          {
            label: "REPORTS",
            path: formatRoute(routes.reports, {
              facilityId: facility.id,
              reportName: "lost",
            }),
          },
          {
            label: "ALERTS",
            path: formatRoute(routes.alerts, { facilityId: facility.id }),
          },
          {
            label: (
              <span>
                UTILIZATION <span className="beta">beta</span>
              </span>
            ),
            path: formatRoute(routes.utilization, {
              facilityId: facility.id,
            }),
          },
        ]
      : []
    const firstNameInitial = user ? user.firstName[0] : ""
    const lastNameInitial = user ? user.lastName[0] : ""
    return {
      urlPath: ownProps.urlPath,
      initials: firstNameInitial + lastNameInitial,
      facilityName: facility ? facility.name : "SwipeSense",
      navLinks: navLinks,
      applications:
        user &&
        user.applications
          .map(({ name, ...rest }) => ({ text: name, ...rest }))
          .filter(app => app.text !== "Asset Tracking"),
      ...ownProps,
    }
  },
})(Header)

HeaderWithApollo.propTypes = {
  facilityId: PropTypes.string,
  urlPath: PropTypes.any,
}

const ContextualHeader = connect(({ router }) => {
  const match = createMatchSelector(routes.facility)({ router })
  const facilityId = match ? match.params.facilityId : null
  return {
    facilityId: facilityId,
    urlPath: router.location.pathname,
  }
})(HeaderWithApollo)

export default () => (
  <ErrorBoundary errorComponent={Header}>
    <ContextualHeader />
  </ErrorBoundary>
)
